import React , {Children, useEffect, useState, lazy, Suspense } from 'react';
import type { MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom' ;
import Footer from '../../components/footer';
import { useScroll } from '../../contexts/ScrollContext';
import { useViewport } from '../../contexts/ViewportContext';
import bannar from '../../images/banner.jpg'
import soft from '../../images/soft.png'
import digital from '../../images/digital.png'
import aiImg from '../../images/aiImg.jpg'
import dataOutside from '../../images/dataOutside.jpg'
import city from '../../images/city.png'
import wechatQd from '../../images/wechat.png'
import './index.scss';
import 'animate.css';

type MenuItem = Required<MenuProps>['items'][number];

const items: MenuItem[] = [
    {
      label: '首页',
      key: '0',
    },
    {
      label: '服务优势',
      key: '1',
      children: [
        { label: '软件定制开发', key: '4' },
        { label: 'AI', key: '5' },
        { label: '数字化转型集成', key: '6'},
        { label: '面向数据要素', key: '7' },
      ]
    },
    {
      label: '应用领域',
      key: '2',
    },
    {
        label: '关于我们',
        key: '3',
      },
];

const HomePage = () => {
    const prefixCls = 'homepage';

    const navigate = useNavigate();
    const { width } = useViewport();

    return <div className={prefixCls}>
        <div>
            <div className={`${prefixCls}-top`} >
                <img src={city} className={`${prefixCls}-top-img`} alt=''/>
                <div className={`${prefixCls}-top-mask`}></div>
                <div className={`${prefixCls}-top-text animate__animated animate__fadeInUp` } style={{bottom: width < 768 ? '160px' : '60px'}}>
                    <div className={`${prefixCls}-top-text-title`}>追光筑软，互联未来</div>
                    <div className={`${prefixCls}-top-text-subtitle`}>致力于聚焦数字化转型咨询、AI、数据治理、软件开发能力，助力千行百业的数字化转型进程。
                </div>
            </div>
        </div>
        {   
            width < 768 && 
            <div className={`${prefixCls}-card`}>
                <div className={`${prefixCls}-card-top`}>
                {/* <div className={`${prefixCls}-card-top-avatar`}></div> */}
                    <div className={`${prefixCls}-card-top-spacer`}></div>
                    <div className={`${prefixCls}-card-top-name`}>
                        <h4>吕明轩</h4>
                        <span style={{margin: "0 8px"}}>|</span>
                        <div>销售总监</div>
                    </div>
                    <div className={`${prefixCls}-card-top-type`}>软件行业</div>
                </div>
                <div className={`${prefixCls}-card-info`}>
                    <div className={`${prefixCls}-card-info-connect`}>
                        <div>
                            <h4>陕西图南数字科技有限公司</h4>
                            <div className={`${prefixCls}-card-info-connect-section`}>                           
                                <div style={{display: "flex",alignItems:"center"}}>
                                    <p>联系电话：15249118888</p>
                                    <a href="tel:15249118888">联系Ta</a>
                                </div> 
                                <div>邮箱：173025071@qq.com</div>                           
                            </div>
                        </div>
                        <div className={`${prefixCls}-card-info-connect-code`}>
                            <img src={wechatQd} style={{width:'50px',height:'auto'}}/>
                            <div style={{fontSize: "12px"}}>微信</div>
                        </div>
                    </div>
                </div>
            </div>
        }
            <div className={`${prefixCls}-content`} style={{marginTop: width < 768 ? '30px' : '0px'}}>
                <div className={`${prefixCls}-content-section`} style={{background:'#f6f6f6'}}>
                <div className={`${prefixCls}-content-section-container`}>
                        <div className={`${prefixCls}-content-section-img`}>
                            <img src={soft} loading="lazy" className={`${prefixCls}-content-section-img-video`}/>
                            <div className={`${prefixCls}-content-section-img-mask`}></div>
                        </div>
                        <div className={`${prefixCls}-content-section-text ${prefixCls}-content-section-text-left`}>
                            <div className={`${prefixCls}-title`}>软件定制开发</div>
                            <div className={`${prefixCls}-subtitle`}>提供从需求分析、系统设计、编码实现、集成测试、部署交付、维护支持的整个软件生命周期服务。</div>
                            <div className={`${prefixCls}-btn`} onClick={() => navigate('/server/sofeware')}>马上开始</div>
                        </div>
                    </div>
                </div>
                <div className={`${prefixCls}-content-section`}> 
                    <div className={`${prefixCls}-content-section-container`}>
                    <div className={`${prefixCls}-content-section-text ${prefixCls}-content-section-text-right`}>
                        <div className={`${prefixCls}-title`}>数字化转型咨询</div>
                        <div className={`${prefixCls}-subtitle`}>助力组织梳理解决战略规划、架构设计、流程优化、系统建设等维度问题，端到端推动政企数字化转型。</div>
                        <div className={`${prefixCls}-btn`} onClick={() => navigate('/server/digitizing')}>马上开始</div>
                    </div>
                    <div className={`${prefixCls}-content-section-img`}>
                        <img src={digital} loading="lazy" className={`${prefixCls}-content-section-img-video`}/>
                        <div className={`${prefixCls}-content-section-img-mask`}></div>
                    </div>
                    </div>
                </div>
                <div className={`${prefixCls}-content-section`} style={{background:'#f6f6f6'}}>
                <div className={`${prefixCls}-content-section-container`}>
                    <div className={`${prefixCls}-content-section-img`}>
                        <img src={aiImg} loading="lazy" className={`${prefixCls}-content-section-img-video`}/>
                        <div className={`${prefixCls}-content-section-img-mask`}></div>
                    </div>
                    <div className={`${prefixCls}-content-section-text ${prefixCls}-content-section-text-left` }>
                        <div className={`${prefixCls}-title`}>AI to B</div>
                        <div className={`${prefixCls}-subtitle`}>致力于构建行业大模型、协助政企打造专属Chat BI、智能语音助手等新质生产力工具。</div>
                        <div className={`${prefixCls}-btn`} onClick={() => navigate('/server/ai')}>马上开始</div>
                    </div>
                    </div>
                </div>
                <div className={`${prefixCls}-content-section`}> 
                <div className={`${prefixCls}-content-section-container`}>
                    <div className={`${prefixCls}-content-section-text ${prefixCls}-content-section-text-right`}>
                        <div className={`${prefixCls}-title`}>面向数据要素</div>
                        <div className={`${prefixCls}-subtitle`}>为政府、机构、企业提供数字化产品和解决方案，提供数字化平台软件定制开发服务，提供数字化平台的后续技术服务。</div>
                        <div className={`${prefixCls}-btn`} onClick={() => navigate('/server/dataOriented')}>马上开始</div>
                    </div>
                    <div className={`${prefixCls}-content-section-img`}>
                        <img src={dataOutside} loading="lazy" className={`${prefixCls}-content-section-img-video`}/>
                        <div className={`${prefixCls}-content-section-img-mask`}></div>
                    </div>
                    {/* <div className={`${prefixCls}-content-section-img`}>
                        <video
                            className={`${prefixCls}-content-section-img-video`}
                            autoPlay
                            loop
                            src='https://www.envision-group.com/videos/smart-1.mp4'
                            muted
                        />
                        <div className={`${prefixCls}-content-section-img-mask`}></div>
                    </div> */}
                </div>
                </div>
            </div>
        </div>
        <Footer />
        {/* <div className={`${prefixCls}-footer`}>
                <div className={`${prefixCls}-footer-content`}>
                    {footerTextList.map((item)=>{
                        return <div className={`${prefixCls}-footer-content-item`}>
                            <div className={`${prefixCls}-footer-title`}>{item.title}</div>
                            {item.children.length>0 && item.children.map((item)=>{
                                return <div className={`${prefixCls}-footer-subtitle`} onClick={()=>window.open('https://wwww.baidu.com')} style={{display:'block'}}>
                                    {item.title}
                                </div>
                            })}
                        </div>
                    })}
                </div>
            </div> */}
    </div>
    {/* </Suspense> */}
}

export default HomePage;